var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content talent-management" }, [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: "exportView", role: "dialog" }
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("form", { staticClass: "form-inline" }, [
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [
                        _vm._v(
                          "\n                            Select Year\n                            "
                        ),
                        _c("v-select", {
                          attrs: {
                            name: "sele_year",
                            id: "sele_year",
                            clearable: false,
                            label: "name",
                            filterable: true,
                            options: _vm.sele_yearArr,
                            placeholder: "Select Year"
                          },
                          model: {
                            value: _vm.export_year,
                            callback: function($$v) {
                              _vm.export_year = $$v
                            },
                            expression: "export_year"
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.export_yearerr))
                        ]),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                            Select Grade\n                            "
                        ),
                        _c("v-select", {
                          attrs: {
                            name: "sele_grade",
                            id: "sele_grade",
                            label: "name",
                            filterable: true,
                            options: _vm.sele_gradeArr,
                            clearable: true,
                            placeholder: "Select Grade"
                          },
                          model: {
                            value: _vm.export_grade,
                            callback: function($$v) {
                              _vm.export_grade = $$v
                            },
                            expression: "export_grade"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [_vm._v("---- OR ----")]
                        ),
                        _vm._v(
                          "\n                            Select Manager/HR\n                            "
                        ),
                        _c("v-select", {
                          attrs: {
                            name: "sele_grade",
                            id: "sele_grade",
                            clearable: true,
                            label: "text",
                            filterable: true,
                            options: _vm.hr_managerArr,
                            placeholder: "Manager/HR"
                          },
                          model: {
                            value: _vm.export_user,
                            callback: function($$v) {
                              _vm.export_user = $$v
                            },
                            expression: "export_user"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [_vm._v("---- OR ----")]
                        ),
                        _vm._v(
                          "\n                            Select Location\n                            "
                        ),
                        _c("v-select", {
                          attrs: {
                            name: "sele_grade",
                            id: "sele_grade",
                            clearable: true,
                            label: "text",
                            filterable: true,
                            options: _vm.locationArr,
                            placeholder: "Location"
                          },
                          model: {
                            value: _vm.export_location,
                            callback: function($$v) {
                              _vm.export_location = $$v
                            },
                            expression: "export_location"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "row mt-3 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mr-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.exportData()
                                  }
                                }
                              },
                              [_vm._v("Export")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger waves-effect",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal"
                                }
                              },
                              [_vm._v("Close")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("form", { attrs: { id: "talentManagement" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c(
                "div",
                { staticClass: "top-header float-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary waves-effect pull-right ml-2",
                      attrs: {
                        type: "button",
                        "data-toggle": "modal",
                        id: "exportModel",
                        title: "Export",
                        "data-target": "#exportView"
                      }
                    },
                    [_vm._v("Export")]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "year-filter filter",
                    attrs: {
                      name: "sele_year",
                      id: "sele_year",
                      disable: true,
                      clearable: false,
                      label: "name",
                      filterable: true,
                      options: _vm.sele_yearArr,
                      placeholder: "Select Year"
                    },
                    on: {
                      input: function($event) {
                        return _vm.changedValueYear()
                      }
                    },
                    model: {
                      value: _vm.year,
                      callback: function($$v) {
                        _vm.year = $$v
                      },
                      expression: "year"
                    }
                  }),
                  _vm._v(" "),
                  _vm.isVisibleMAnagers
                    ? _c("v-select", {
                        staticClass: "year-filter filter",
                        attrs: {
                          name: "sele_year",
                          id: "sele_year",
                          disable: true,
                          clearable: true,
                          label: "text",
                          filterable: true,
                          options: _vm.hr_managerArr,
                          placeholder: "Select Manager/HR"
                        },
                        on: {
                          input: function($event) {
                            return _vm.changedValueView()
                          }
                        },
                        model: {
                          value: _vm.view_manager,
                          callback: function($$v) {
                            _vm.view_manager = $$v
                          },
                          expression: "view_manager"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "toggle1" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal fade",
                    attrs: { id: "viewMore", role: "dialog" }
                  },
                  [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "h4",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "defaultModalLabel" }
                            },
                            [_vm._v("Grade " + _vm._s(_vm.grade) + " Users")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "ul",
                                  { staticClass: "list-user" },
                                  _vm._l(_vm.empList, function(obj, index) {
                                    return _c(
                                      "li",
                                      {
                                        staticStyle: { "list-style": "decimal" }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.showProfile(
                                                  obj.value
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(obj.text) +
                                                "\n                                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "fa fa-times ml-5",
                                          class: {
                                            disableclick: _vm.isDisableYear
                                          },
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.removeUser(
                                                obj,
                                                _vm.grade
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.empList == 0
                                  ? [
                                      _vm._v(
                                        "\n                                                    No User available\n                                                "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary float-right",
                                attrs: {
                                  "data-dismiss": "modal",
                                  type: "submit"
                                }
                              },
                              [_vm._v("Close")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nine-box toggle-content desktop-content" },
                  [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "priority" }, [
                            _vm._v("high")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("C1")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "c1",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    clearable: true,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.changedValue == null
                                    },
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "c1",
                                        _vm.sele_empc1
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empc1,
                                    callback: function($$v) {
                                      _vm.sele_empc1 = $$v
                                    },
                                    expression: "sele_empc1"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.c1Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.c1Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(obj.text) +
                                                      "\n                                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "c1"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("C1", _vm.c1Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("B1")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "b1",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    clear: true,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "b1",
                                        _vm.sele_empArr
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empb1,
                                    callback: function($$v) {
                                      _vm.sele_empb1 = $$v
                                    },
                                    expression: "sele_empb1"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.b1Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.b1Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "b1"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("B1", _vm.b1Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("A1")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "a1",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "a1",
                                        _vm.sele_empa1
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empa1,
                                    callback: function($$v) {
                                      _vm.sele_empa1 = $$v
                                    },
                                    expression: "sele_empa1"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.a1Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.a1Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "a1"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("A1", _vm.a1Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "priority avrpriority" }, [
                            _vm._v("average")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("C2")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "c2",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "c2",
                                        _vm.sele_empc2
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empc2,
                                    callback: function($$v) {
                                      _vm.sele_empc2 = $$v
                                    },
                                    expression: "sele_empc2"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.c2Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.c2Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "c2"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("C2", _vm.c2Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("B2")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "b2",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "b2",
                                        _vm.sele_empb2
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empb2,
                                    callback: function($$v) {
                                      _vm.sele_empb2 = $$v
                                    },
                                    expression: "sele_empb2"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.b2Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.b2Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "b2"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("B2", _vm.b2Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("A2")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "a2",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "a2",
                                        _vm.sele_empa2
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empa2,
                                    callback: function($$v) {
                                      _vm.sele_empa2 = $$v
                                    },
                                    expression: "sele_empa2"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.a2Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.a2Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "a2"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("A2", _vm.a2Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "priority" }, [
                            _vm._v("low")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "performance show1" }, [
                            _vm._v("low")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("C3")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "c3",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "c3",
                                        _vm.sele_empc3
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empc3,
                                    callback: function($$v) {
                                      _vm.sele_empc3 = $$v
                                    },
                                    expression: "sele_empc3"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.c3Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.c3Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "c3"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("C3", _vm.c3Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "performance show1" }, [
                            _vm._v("average")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("B3")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "b3",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "b3",
                                        _vm.sele_empb3
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empb3,
                                    callback: function($$v) {
                                      _vm.sele_empb3 = $$v
                                    },
                                    expression: "sele_empb3"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.b3Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.b3Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "b3"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("B3", _vm.b3Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c(
                            "div",
                            { staticClass: "performance desk-content" },
                            [_vm._v("high")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("A3")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "a3",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "a3",
                                        _vm.sele_empa3
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empa3,
                                    callback: function($$v) {
                                      _vm.sele_empa3 = $$v
                                    },
                                    expression: "sele_empa3"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.a3Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.a3Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "a3"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("A3", _vm.a3Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "toggle2" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nine-box toggle-content mobile-content" },
                  [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "priority" }, [
                            _vm._v("low")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("C1")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "c1",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "c1",
                                        _vm.sele_empc1
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empc1,
                                    callback: function($$v) {
                                      _vm.sele_empc1 = $$v
                                    },
                                    expression: "sele_empc1"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.c1Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.c1Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "c1"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("C1", _vm.c1Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("C2")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "c2",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "c2",
                                        _vm.sele_empc2
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empc2,
                                    callback: function($$v) {
                                      _vm.sele_empc2 = $$v
                                    },
                                    expression: "sele_empc2"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.c2Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.c2Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "c2"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("C2", _vm.c2Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("C3")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "c3",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "c3",
                                        _vm.sele_empc3
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empc3,
                                    callback: function($$v) {
                                      _vm.sele_empc3 = $$v
                                    },
                                    expression: "sele_empc3"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.c3Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.c3Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "c3"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("C3", _vm.c3Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "priority avrpriority" }, [
                            _vm._v("average")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("B1")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "b1",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "b1",
                                        _vm.sele_empb1
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empb1,
                                    callback: function($$v) {
                                      _vm.sele_empb1 = $$v
                                    },
                                    expression: "sele_empb1"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.b1Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.b1Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "b1"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("B1", _vm.b1Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("B2")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "b2",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "b2",
                                        _vm.sele_empb2
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empb2,
                                    callback: function($$v) {
                                      _vm.sele_empb2 = $$v
                                    },
                                    expression: "sele_empb2"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.b2Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.b2Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "b2"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("B2", _vm.b2Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("B3")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "b3",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "b3",
                                        _vm.sele_empb3
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empb3,
                                    callback: function($$v) {
                                      _vm.sele_empb3 = $$v
                                    },
                                    expression: "sele_empb3"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.b3Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.b3Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "b3"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("B3", _vm.B3Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "priority" }, [
                            _vm._v("high")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("A1")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "a1",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "a1",
                                        _vm.sele_empa1
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empa1,
                                    callback: function($$v) {
                                      _vm.sele_empa1 = $$v
                                    },
                                    expression: "sele_empa1"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.a1Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.a1Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "a1"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("A1", _vm.a1Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "performance show1" }, [
                            _vm._v("average")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("A2")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "a2",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "a2",
                                        _vm.sele_empa2
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empa2,
                                    callback: function($$v) {
                                      _vm.sele_empa2 = $$v
                                    },
                                    expression: "sele_empa2"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.a2Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.a2Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "a2"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("A2", _vm.a2Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 col-sm-12 sections" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c("h4", { staticClass: "title" }, [_vm._v("A3")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-section" },
                              [
                                _c("v-select", {
                                  ref: "a3",
                                  class: { disabledSelect: _vm.isDisableYear },
                                  attrs: {
                                    name: "sele_emp",
                                    id: "sele_emp",
                                    label: "text",
                                    filterable: true,
                                    options: _vm.sele_empArr,
                                    placeholder: "Select User"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueUser(
                                        "a3",
                                        _vm.sele_empa3
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.sele_empa3,
                                    callback: function($$v) {
                                      _vm.sele_empa3 = $$v
                                    },
                                    expression: "sele_empa3"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-user" },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "list-group",
                                  attrs: {
                                    list: _vm.a3Emp,
                                    group: "people",
                                    disabled: _vm.isDisableYear
                                  },
                                  on: { change: _vm.log }
                                },
                                [
                                  _vm._l(_vm.a3Emp, function(obj, index) {
                                    return [
                                      index < 4
                                        ? [
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.showProfile(
                                                        obj.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(obj.text))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-times ml-5",
                                                class: {
                                                  disableclick:
                                                    _vm.isDisableYear
                                                },
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeUser(
                                                      obj,
                                                      "a3"
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary view-more",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                id: "viewMoreModel",
                                title: "View More",
                                "data-target": "#viewMore"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.viewMore("A3", _vm.a3Emp)
                                }
                              }
                            },
                            [_vm._v("View More")]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name", attrs: { id: "benefitHeader" } }, [
        _vm._v("\n                Talent Management\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "defaultModalLabel" } },
        [_vm._v("Export Data")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "error", attrs: { id: "errorMsg" } }),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "potential tree-toggle1" }, [
      _c("img", { attrs: { src: "/../static/images/potential.png" } }),
      _vm._v(" "),
      _c("span", { staticClass: "hide1 toggle-title" }, [
        _vm._v("Performance "),
        _c("i", {
          staticClass: "fa fa-angle-down",
          attrs: { "aria-hidden": "true" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "performance tree-toggle1" }, [
      _c("img", { attrs: { src: "/../static/images/performance.png" } }),
      _vm._v(" "),
      _c("span", { staticClass: "hide1 toggle-title" }, [
        _vm._v("Potential "),
        _c("i", {
          staticClass: "fa fa-angle-down",
          attrs: { "aria-hidden": "true" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa22cf98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa22cf98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/9box/9Box.vue
// module id = null
// module chunks = 